var exports = {
  "m": "Wrapper__SLlsS4",
  "H": "Canvas__UQ860h",
};

module.exports = exports;
